import { DateTime } from "luxon";
import PropTypes from "prop-types";
import React from "react";

const DrEventListItem = ({ item }) => {
  return (
    <div className="flex flex-row">
      <div className="flex flex-col items-start">
        <div className="font-bold">
          <span>
            {DateTime.fromMillis(item.eventStart).toFormat("dd MMM yyyy")}
            ,&nbsp;
          </span>
          <span>{DateTime.fromMillis(item.eventStart).toFormat("hh a")}</span>
          <span>&nbsp;To&nbsp;</span>
          <span>{DateTime.fromMillis(item.eventEnd).toFormat("hh a")}</span>
        </div>
        <div>{item.resourceActivations.length} Resources Activated</div>
      </div>
    </div>
  );
};

DrEventListItem.propTypes = {
  item: PropTypes.object.isRequired
};

export default DrEventListItem;
